import { Flex, Box, StyleSystemProps, styled } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledWrapper = styled(Flex)``;
const wrapperStyles: StyleSystemProps = {
  border: '1px solid',
  borderColor: 'mono3',
  borderRadius: pxToRem(12)
};

export const StyledExpandableWrapper = styled(Flex)``;

export const StyledRightContentWrapper = styled(Flex)``;
const rightContentWrapperStyles: StyleSystemProps = {
  paddingY: 5,
  paddingX: 4,
  flexDirection: 'column',
  transition: 'opacity ease-in-out 300ms'
};

export const StyledLeftContentWrapper = styled(Flex)``;
const leftContentWrapperStyles: StyleSystemProps = {
  height: '100%',
  flexDirection: 'column',
  paddingY: 5,
  paddingX: 4
};

export const StyledDivider = styled(Box)``;
const dividerStyles: StyleSystemProps = {
  borderRight: '1px solid',
  borderColor: 'mono3',
  minHeight: '100%'
};

export const StyledProgressSummaryContentWrapper = styled(Flex)``;
const progressSummaryContentWrapperStyles: StyleSystemProps = {
  borderBottom: '1px solid',
  borderColor: 'mono3',
  flexDirection: 'column',
  paddingBottom: 5,
  paddingX: 6
};

export const giftCountsStateContentWrapperStyles: StyleSystemProps = {
  justifyContent: 'center',
  height: '100%',
  flexDirection: 'column'
};

export const styles = {
  wrapper: wrapperStyles,
  rightContentWrapper: rightContentWrapperStyles,
  leftContentWrapper: leftContentWrapperStyles,
  divider: dividerStyles,
  progressSummaryContentWrapper: progressSummaryContentWrapperStyles,
  giftCountsStateContentWrapper: giftCountsStateContentWrapperStyles
};
